'use client';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';
import { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import { StyledItem, ArrowDown } from './styles';

const CarouselItem = ({ category, link, image, imageContent, darkMode, isAnySelected }) => {
  const { path } = useCurrentUrl();
  const linkObj = buildLinkObj(link);
  const imgUrl = buildImageSrc(imageContent?.image ? imageContent : image, 60, 1, 1);

  const [selected, setSelected] = useState(false);

  useEffect(() => {
    setSelected(!!path && !!link && path === link.link);
  }, [path, link]);

  return (
    <>
      <StyledItem
        rel={getRel(linkObj)}
        href={`${linkObj.href}`}
        darkMode={darkMode}
        selected={selected}
        isAnySelected={isAnySelected}
      >
        {imgUrl && (
          <LazyLoadImage
            imgComponent={
              /* eslint-disable-next-line @next/next/no-img-element */
              <img src={imgUrl} alt="" />
            }
          />
        )}
        <Typography
          component="span"
          variant="h6"
          align="center"
          sx={{
            letterSpacing: '0.2px',
            fontSize: { xs: '1.3rem', md: '1.7rem' },
            lineHeight: { xs: '1.3rem', md: '1.7rem' },
            color: (theme) => (darkMode ? theme.palette.neutral[50] : theme.palette.text.primary),
          }}
        >
          {category}
        </Typography>
      </StyledItem>
      {selected && <ArrowDown />}
    </>
  );
};

export default CarouselItem;
